<template>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'aboutCompany',
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/AboutCompany.vue?f6dd3b0e